import { SelectOption } from '@core/models';

export const TradingPartners: SelectOption<string>[] = [
  { key: 'ABBVIE', desc: 'Abbvie Inc.', value: 'Abbvie Inc.' },
  { key: 'DHL', desc: 'DHL Logistics', value: 'DHL Logistics' },
  { key: 'IDL', desc: 'ID Logistics', value: 'ID Logistics' },
  { key: 'ALLOGAUK', desc: 'Alloga UK', value: 'Alloga UK' },
];
